import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import {isPlatformBrowser} from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class HtmlElementService {
  constructor(@Inject(PLATFORM_ID) public platformId: object) {}

  public getAbsoluteHeight(element: HTMLElement): number {
    if (isPlatformBrowser(this.platformId)) {
      const styles: CSSStyleDeclaration = window.getComputedStyle(element);
      const margin: number = parseFloat(styles.marginTop || '0') + parseFloat(styles.marginBottom || '0');
      return Math.ceil(element.offsetHeight + margin);
    }
    return 0;
  }

  public documentOffset(): number {
    if (isPlatformBrowser(this.platformId)) {
      return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    }
    return 0;
  }
}
